import React from "react";
import { useActivateAccount } from "../../hooks/useActivateAccount";
import ActivateAccountView from "./ActivateAccountView";

function ActivateAccountContainer() {
    const { message } = useActivateAccount();
    return <ActivateAccountView message={message} />;
}

export default ActivateAccountContainer;
